import { TrendingDown, TrendingUp } from "lucide-react";
import React from "react";

const StatCards = ({ title, value, pillText, trend, period }) => {
  return (
    <div className="bg-content flex-1 shadow-lg h-40 rounded-lg p-4 text-text-1 border border-bkg2">
      <div className="flex mb-8 items-start justify-between">
        <div>
          <h4 className="mb-2 text-sm text-text-1/60">{title}</h4>
          <p className="text-3xl sm:text-xl md:text-xl lg:text-2xl font-semibold">
            {value}
          </p>
        </div>
        <span
          className={`text-xs flex items-center gap-1 font-medium px-2 py-1 rounded ${
            trend === "up"
              ? "bg-green-200 text-green-700"
              : "bg-red-200 text-red-700"
          }`}
        >
          {trend === "up" ? (
            <TrendingUp size={15} />
          ) : (
            <TrendingDown size={15} />
          )}
          {pillText}
        </span>
      </div>
      <p className="text-xs text-text-1/60">{period}</p>
    </div>
  );
};

export default StatCards;
